import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiCallingService {

  url: string = "";
  public static BASE_URL = environment.statusCode;

  constructor(public http: HttpClient, private router: Router) { }
  /**
   * GET HAEDER 
   * @return httpHeaders
   */
  getHeader() {
    let httpHeaders = new HttpHeaders();
    httpHeaders.append("Accept", "application/json");
    httpHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    return httpHeaders;
  }
  getAuthHeader() {
    let token = localStorage.getItem("Auth-token");
    let httpHeaders = new HttpHeaders({
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "" + token,
    });
    return httpHeaders;
  }
  getAuthPostHeader() {
    let token = localStorage.getItem("Auth-token");
    let httpHeaders = new HttpHeaders({
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "" + token,
    });
    return httpHeaders;
  }
  /**
   * Method will call without login
   * @param email
   * @param pwd
   * @return httpResponse
   */
  callAPI(body: object, type: String, url: string): Observable<any> {
    let headers: HttpHeaders = this.getHeader();
    let options = {
      headers: headers,
    };
    if (type == "POST") {
      return this.http.post(url, body, options);
    } else if (type == "PUT") {
      return this.http.put(url, body, options);
    } else if (type == "DELETE") {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }
  /**
   * Method will call with login
   * @param email
   * @param pwd
   * @return httpResponse
   */
  callAuthAPI(body: object, type: String, url: string): Observable<any> {
    let token = localStorage.getItem("Auth-user");
    if (!token) {
      this.router.navigate(["/login"]);
    }
    let headers: HttpHeaders = this.getAuthHeader();
    let options = {
      headers: headers,
    };
    if (type == "POST") {
      return this.http.post(url, body, options);
    } else if (type == "PUT") {
      return this.http.put(url, body, options);
    } else if (type == "DELETE") {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }
  callAuthPostAPI(body: object, type: String, url: string): Observable<any> {
    let token = localStorage.getItem("Auth-user");
    if (!token) {
      this.router.navigate(["/login"]);
    }
    let headers: HttpHeaders = this.getAuthPostHeader();
    let options = {
      headers: headers,
    };
    if (type == "POST") {
      return this.http.post(url, body, options);
    } else if (type == "PUT") {
      return this.http.put(url, body, options);
    } else if (type == "GET") {
      return this.http.get(url, options);
    } else {
      return this.http.delete(url, options);
    }
  }
  callAPIwithFile(body: object, type: String, url: string): Observable<any> {
    let token = localStorage.getItem("Auth-user");
    if (!token) {
      this.router.navigate(["/authentication/login"]);
    }

    let options = {};
    if (type == "POST") {
      return this.http.post(url, body, options);
    } else if (type == "PUT") {
      return this.http.put(url, body, options);
    } else if (type == "DELETE") {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }

  customAPI(
    header: any,
    body: object,
    type: String,
    url: string
  ): Observable<any> {
    let headers: HttpHeaders = header;
    let options = {
      headers: headers,
    };
    if (type == "POST") {
      return this.http.post(url, body, options);
    } else if (type == "PUT") {
      return this.http.put(url, body, options);
    } else if (type == "DELETE") {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }

  handleSuccess(res: any) {
    if (res.ResponseCode == 200) {
      return true;
    } else {
      return false;
    }
  }
}
